export { createSeenList } from '../../utils/seenList';

export const battleSeenKey = (userId: number | string, runKey: string, segmentKey: string) =>
  `${userId}:${runKey}:${segmentKey}`;
